import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '../helpers/user.helper.js'


const API_URL = process.env.VUE_APP_API_URL + 'balise/';

class BaliseService {

    getGroupBalisesLastPositions(search = null, badge = 0) {

        return search == null ?
            axios.get(API_URL + 'getclientbalises/' + UserHelper.getClientId(),
                {
                    params: { badge: badge },
                    headers: authHeader()
                })
            :
            axios.get(
                API_URL + 'getclientbalises/' + UserHelper.getClientId(),
                {
                    params: { search: search, badge: badge },
                    headers: authHeader()
                });
    }

    getBadgeBalises(number) {

        return axios.get(API_URL + 'getbadgebalises/' + UserHelper.getClientId(),
            {
                params: { number: number },
                headers: authHeader()
            })

    }

    getAllBalises(params = null) {
        // Compat: string => search
        if (typeof params === 'string' || params == null) {
            const search = params || null;
            return search == null
                ? axios.get(API_URL + 'getallbalises', { headers: authHeader() })
                : axios.get(API_URL + 'getallbalises', { params: { search }, headers: authHeader() });
        }
        const { search, clientId, groupId } = params;
        return axios.get(API_URL + 'getallbalises', {
            params: {
                ...(search ? { search } : {}),
                ...(clientId ? { clientId } : {}),
                ...(groupId ? { groupId } : {})
            },
            headers: authHeader()
        });
    }

    updateOrder(clientId, orderedBaliseIds) {
        return axios.put(API_URL + "updateorder/" + clientId, {
            orderedBaliseIds
        }, {
            headers: authHeader()
        });
    }

    getBaliseInfo(baliseId) {
        return axios.get(API_URL + 'getbaliseinfo/' + baliseId, { headers: authHeader() });
    }

    getAlarmTypeConfigs(baliseId) {
        return axios.get(API_URL + 'alarmtypeconfigs/' + baliseId, { headers: authHeader() });
    }

    updateAlarmTypeConfigs(baliseId, configs) {
        return axios.put(
            API_URL + 'alarmtypeconfigs/' + baliseId,
            { configs },
            { headers: authHeader() }
        );
    }

    updateName(baliseId, name) {
        return axios.put(
            API_URL + 'update/' + baliseId,
            { name: name },
            { headers: authHeader() }
        );
    }

    updateGroup(baliseId, groupId) {
        return axios.put(
            API_URL + 'update/' + baliseId,
            { groupId: groupId },
            { headers: authHeader() }
        );
    }

    updateIcon(baliseId, icon) {
        return axios.put(
            API_URL + 'update/' + baliseId,
            { icon: icon },
            { headers: authHeader() }
        );
    }

    updateData(baliseId, data) {
        return axios.put(API_URL + 'update/' + baliseId, data, { headers: authHeader() });
    }

    setParking(baliseId) {
        return axios.put(API_URL + 'setParking/' + baliseId, {}, { headers: authHeader() });
    }

    removeParking(baliseId) {
        return axios.put(API_URL + 'removeParking/' + baliseId, {}, { headers: authHeader() });
    }

    createBalise(baliseData) {
        return axios.post(API_URL + 'create', baliseData, { headers: authHeader() });
    }
    deleteHistory(baliseId) {
        return axios.delete(API_URL + 'deletehistory/' + baliseId, { headers: authHeader() });
    }
}

export default new BaliseService();